"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var feedback_shop_link_1 = require("./feedback_shop_link");
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query Core_Feedback_SellerShopInfo(\n      $listingId: String\n      $channel: core_apimessages_Channel\n    ){\n      listing(input: { id: $listingId }) {\n        shop(input: { channel: $channel }) {\n          name\n          slug\n        }\n      }\n    }\n  "], ["\n    query Core_Feedback_SellerShopInfo(\n      $listingId: String\n      $channel: core_apimessages_Channel\n    ){\n      listing(input: { id: $listingId }) {\n        shop(input: { channel: $channel }) {\n          name\n          slug\n        }\n      }\n    }\n  "]))), {
    options: function (ownProps) {
        return {
            ssr: true,
            variables: {
                listingId: ownProps.listingId,
                channel: ownProps.channel,
            },
        };
    },
});
var FeedbackSellerShopInfo = /** @class */ (function (_super) {
    tslib_1.__extends(FeedbackSellerShopInfo, _super);
    function FeedbackSellerShopInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FeedbackSellerShopInfo.prototype, "loading", {
        get: function () {
            return this.props.data.loading !== false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeedbackSellerShopInfo.prototype, "shop", {
        get: function () {
            return this.props.data.listing.shop;
        },
        enumerable: true,
        configurable: true
    });
    FeedbackSellerShopInfo.prototype.renderPlaceholder = function () {
        return (React.createElement("div", { className: "feedback-seller-shop-info feedback-seller-shop-info--placeholder" }));
    };
    FeedbackSellerShopInfo.prototype.render = function () {
        if (this.loading) {
            return this.renderPlaceholder();
        }
        return (React.createElement(feedback_shop_link_1.default, { shop: this.shop, channel: this.props.channel }));
    };
    return FeedbackSellerShopInfo;
}(React.Component));
exports.FeedbackSellerShopInfo = FeedbackSellerShopInfo;
exports.default = connect(FeedbackSellerShopInfo);
var templateObject_1;
//# sourceMappingURL=feedback_seller_shop_info.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/feedbacks/feedback_seller_shop_info.js
// module id = G0xm
// module chunks = 20 21